import { CommonService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type RepairOrderJobFromQuote = {
  id: number;
  userId?: number;
};
export const useCommonRepairOrderJobFromQuoteMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CommonService.postCommonRepairOrderJobFromQuote>>,
      QueryError,
      RepairOrderJobFromQuote,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id, userId }) => {
      return CommonService.postCommonRepairOrderJobFromQuote(id, userId);
    },
    {
      ...options,
      onSuccess: (resp) => {
        if (resp) toast.success('Successfully!');
        else toast.error('Failed to submit CDK');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
